import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../ui/header/header.component';
import { SidebarComponent } from '../../ui/sidebar/sidebar.component';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterModule, HeaderComponent, SidebarComponent],
})
export class ShellComponent {
  isDark = false;
  sidebarOpen = true;
  sidebarCollapsed = false;

  constructor() {}

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }

  collapseSidebar() {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }
}
